import { render, staticRenderFns } from "./BotGalleryMessage.vue?vue&type=template&id=4b1abddf&scoped=true"
import script from "./BotGalleryMessage.vue?vue&type=script&lang=js"
export * from "./BotGalleryMessage.vue?vue&type=script&lang=js"
import style0 from "./BotGalleryMessage.vue?vue&type=style&index=0&id=4b1abddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1abddf",
  null
  
)

export default component.exports